import { Card } from "@blueprintjs/core";
import { FGTextInput } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

const StyledCard = styled(Card)`
  position: relative;
  flex: 1;
  padding-top: 2rem;
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  font-weight: bold;
`;

export interface ICardReadOnlyTextInputProps {
  label: string;
  name: string;
}

export const CardReadOnlyTextInput: React.FunctionComponent<
  ICardReadOnlyTextInputProps
> = ({ label, name }) => {
  return (
    <StyledCard>
      <LabelContainer>{label}</LabelContainer>
      <FGTextInput name={name} noLabel />
    </StyledCard>
  );
};

export default CardReadOnlyTextInput;
